import { render, staticRenderFns } from "./LandingGlp1.vue?vue&type=template&id=0a2be033&scoped=true"
import script from "./LandingGlp1.vue?vue&type=script&lang=js"
export * from "./LandingGlp1.vue?vue&type=script&lang=js"
import style0 from "./LandingGlp1.vue?vue&type=style&index=0&id=0a2be033&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2be033",
  null
  
)

export default component.exports